import React from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";
import CustomButton from "../CustomButton";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const Skills = ({data}) => {
  return (
    <div className="skills">
      <Container className="" >
        
        <Row className="cultures gx-3">
        {data.list?.map((listItem) => (
            <Col lg={4} className="">
              <Card className="h-100">
              <img src={listItem.icon} alt="Close Teams Faster Results" />
               <h5>{listItem.subheading}</h5>
               <h3>{listItem.title}</h3>
               <p className="text-justify">{listItem.content}</p>
              </Card> 
               
            </Col>
             ))}
          </Row>
      </Container>
       
    </div>
  );
};

export default Skills;
